module.exports = __webpack_public_path__ + "media/images/site/main_bkg-beb29a670e39bd02ada5d21fe24c51c5.png";